// Helpers for rendering YouTube links inside an <iframe>.
// YouTube only allows embedding through the "/embed/<id>" URL form; the
// normal "watch?v=" / "youtu.be/" share links are blocked (X-Frame-Options),
// which is why they render as a broken box. We normalize any link to /embed/.

export function isValidYoutubeLink(url) {
  if (!url) return false;
  const pattern = /^(http(s)?:\/\/)?((w){3}\.)?youtu(be|\.be)?(\.com)?\/.+/;
  return pattern.test(url);
}

// Extract the 11-char video id from the common YouTube URL shapes.
export function getYoutubeVideoId(url) {
  if (!url) return "";

  const patterns = [
    /youtube\.com\/embed\/([A-Za-z0-9_-]{11})/, // already an embed url
    /youtu\.be\/([A-Za-z0-9_-]{11})/, // short share url
    /youtube\.com\/shorts\/([A-Za-z0-9_-]{11})/, // shorts
    /[?&]v=([A-Za-z0-9_-]{11})/, // watch?v=
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) return match[1];
  }

  return "";
}

// Return an embeddable URL. Falls back to the original url when no id is found.
export function getYoutubeEmbedUrl(url) {
  const id = getYoutubeVideoId(url);
  return id ? `https://www.youtube.com/embed/${id}` : (url || "");
}
